module.exports = __webpack_public_path__ + "static/module-gift-61ff48a7e21d3fbd1cd6af7f53d4aed8.jpg";